import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-jweb-mpdata-servlet',
	templateUrl:'./JWebMPDataServletPluginCompPage.html',
	styles: [],
	styleUrls:['./JWebMPDataServletPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JWebMPDataServletPluginCompPage
{
	mdContent_1045 = `\`\`\`java
import com.jwebmp.vertx.JWebMPDataServlet;
\`\`\``;
	mdContent_1046 = `\`\`\`java
JWebMPDataServlet()
\`\`\``;
	mdContent_1047 = `\`\`\`java
// Data-bound components automatically refresh via:
// GET /jwdata?componentId=myComponent
// JWebMPDataServlet serializes the component to JSON
\`\`\``;
}
